<template>
  <div id="app">
    <b-nav id="nav">
        <b-nav-item to="/">Home</b-nav-item>
        <b-nav-item v-if="!isAuthenticated" :no-prefetch="true" to="/signin">Sign in</b-nav-item>
        <b-nav-item v-if="!isAuthenticated" :no-prefetch="true" to="/clientcredentials">Client credentials flow</b-nav-item>
        <b-nav-item v-if="isAuthenticated" to="/events">List events</b-nav-item>
        <b-nav-item v-if="isAuthenticated" :no-prefetch="true" href="#" v-on:click="logout()">Sign out</b-nav-item>
        <b-nav-item v-if="!isAuthenticated" :no-prefetch="true" @click="switchEnv()">
        	Environment {{environment}}
        </b-nav-item>
    </b-nav>
    <router-view />
  </div>
</template>

<style lang="scss">
    body {
        margin: 1rem
    }

    a {
        color: #F26524;
    }
    
    .jumbotron{
        background-color: #F26524;
        color: #FFF;
        padding-top: 2rem;
        padding-bottom: 2rem;
    }
</style>

<style>
    @import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
</style>

<script>
import auth from "./services/auth";

export default {
    name: "appmain",
    computed: {
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated;
        }        ,
        environment() {
            return this.$store.getters.environment;
        }
    },
    methods: {
    	switchEnv() {
    		if (this.$store.getters.environment == "dev") {
    			this.$store.dispatch("changeEnvironment", "prod");
    		} else {
    			this.$store.dispatch("changeEnvironment", "dev");
    		}
    	},
       	logout() {
           auth.logout();
       	}
    }
};
</script>
